import React, { memo, useState, useEffect } from 'react';

import * as S from './style';

interface IProps {
  /** count */
  count: number;
  /** label */
  label: string;
}

const Count = ({ count = 0, label }: IProps) => {
  const [$count, setCount] = useState<number>(count);

  useEffect(() => {
    setCount(count);
  }, [count]);

  return (
    <S.Count className="count" aria-label={label}>
      {$count}
    </S.Count>
  );
};

export default memo(Count);
